function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.698 19.4A10.45 10.45 0 0011 21.5c2.308 0 4.5-.746 6.302-2.1a6.503 6.503 0 00-12.604 0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 8,
  r: 4
}));

function SvgAccount(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiPgogICAgICAgIDxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjEwLjUiLz4KICAgICAgICA8cGF0aCBkPSJNNC42OTggMTkuNEExMC40NSAxMC40NSAwIDAgMCAxMSAyMS41YzIuMzA4IDAgNC41LS43NDYgNi4zMDItMi4xYTYuNTAzIDYuNTAzIDAgMCAwLTEyLjYwNCAweiIvPgogICAgICAgIDxjaXJjbGUgY3g9IjExIiBjeT0iOCIgcj0iNCIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgAccount as ReactComponent };